fetch( "https://ipapi.co/json/" )
    .then( response => response.json() )
    .then( data => {
        const country = data.country_name;
        const countryCode = data.country_code;
        console.log( "Access country：", country, "Code：", countryCode );
    
        if ( countryCode !== "CN" ) {
            document.querySelectorAll('.product-price__price').forEach(el => el.style.display = 'block');
            document.querySelectorAll('.product-single__addtocart').forEach(el => el.style.display = 'block');
        }
    } )
    .catch( err => {
        console.error("IP location check error.", err);
    } );

